<template>
  <page>
    <template slot="header">
      <div class="container-fluid mb-2">
        <router-link to="/inventario" class="btn btn-dark mr-2 mb-3">
          <i class="fas fa-angle-double-left"></i>
          {{ $t('Voltar') }}
        </router-link>
        <div class="row">
          <div class="col-sm-6">

            <h3 class="m-0 text-dark">
              {{ $t('contagem_de_itens')}}
            </h3>
          </div>
          <div class="col-sm-6">
            <b-breadcrumb class="float-sm-right" :items="breadcrumbItems"></b-breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template slot='content'>
      <!-- <teste></teste> -->
      <inventario-itens></inventario-itens>
      <os-pagination-inventario></os-pagination-inventario>

    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import InventarioItens from '../components/Armazem/InventarioItens.vue'
import OsPaginationInventario from '../components/OsPaginationInventario.vue'
// import Teste from '../components/Armazem/teste.vue'

export default {
  components: {
    Page,
    InventarioItens,
    OsPaginationInventario
    // Teste
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created() {
    const dsColaborador = this.$store.getters['filial/filial']

  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: this.$t('Inventário de Estoque'),
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
    sendBackPage() {
      window.history.back()
    },
  }

}
</script>
